export const ERROR_CODE: Record<string, string> = {
  ODDS_CHANGED: 'oddsChangedError',
  NOT_ENOUGH_BALANCE: 'notEnoughBalance',
  TOTAL_BETS_ON_BETTING_SLIP: 'totalBetsOnBettingSlipError',
  MAX_STAKE_AMOUNT: 'maxStakeAmountError',
  EVENT_ALREADY_STARTED: 'eventAlreadyStarted',
  INVALID_REQUIRED_HIT_COUNT: 'invalidRequiredHitCount',
  WAYS_BET_CANNOT_HAVE_BANKERS: 'waysBetCannotHaveBankers',
  WON_BETTING_SLIP_WITH_OPEN_BETS: 'wonBettingSlipWithOpenBetsError',
  BETTING_SLIPS_HISTORY_FILTER_MAX_ONE_MONTH_BEFORE: 'bettingSlipsHistoryFilterMaxOneMonthBefore',
  OUTCOME_NOT_ACTIVE: 'outcomeNotActive',
  MARKET_NOT_ACTIVE: 'marketNotActive',
  EVENT_NOT_ACTIVE: 'eventNotActive',
  REOFFERING_FAILED: 'reofferingFailed',
  REOFFERING_REOFFERED_FAILED: 'reofferingReofferedFailed',
  TICKET_TO_REJECT_NOT_FOUND: 'ticketToRejectNotFound',
  TICKET_TO_REOFFER_NOT_FOUND: 'ticketToReofferNotFound',
  ACCEPTANCE_NOT_ALLOWED: 'acceptanceNotAllowed',
  TICKET_SHOULD_BE_PENDING: 'ticketShouldBePending',
  TICKET_SHOULD_BE_ACCEPTED: 'ticketShouldBeAccepted',
  TICKET_CANCELLATION_TIMEOUT: 'ticketCancellationTimeout',
  TICKET_CANCEL_BEFORE_MATCHES: 'ticketCancelBeforeMatches',
  TICKET_STATUS_SHOULD_BE_OPEN: 'ticketStatusShouldBeOpen',
  PLACE_BET_TRANSACTIONS_FAILED: 'placeBetTransactionsFailed',
  CHECK_USER_BALANCE_FAILED: 'checkUserBalanceFailed',
  TICKETS_SHOULD_BE_RESOLVED: 'ticketsShouldBeResolved',
  BONUS_TICKET_MIN_SELECTIONS: 'bonusTicketMinSelectionsError',
  BONUS_TICKET_MIN_ODDS_EACH_SELECTION: 'bonusTicketMinOddsEachSelectionError',
  BONUS_TICKET_MAX_WINNING: 'bonusTicketMaxWinningError',
  BONUS_TICKET_MAX_STAKE_SINGLE: 'bonusTicketMaxStakeSingleError',
  BONUS_TICKET_MAX_SELECTIONS: 'bonusTicketMaxSelectionsError',
  BONUS_TICKET_MAX_TOTAL_ODDS: 'bonusTicketMaxTotalOddsError',
  BONUS_TICKET_MIN_TOTAL_ODDS: 'bonusTicketMinTotalOddsError',
  BONUS_TICKET_MAX_TICKET_STAKE: 'bonusTicketMaxTicketStakeError',
  BONUS_TICKET_MIN_TICKET_STAKE: 'bonusTicketMinTicketStakeError',
  INVALID_CODE: 'invalidCode',
  430: 'ligdiNotEnoughBalance',
  416: 'ligdiExpiredOtp',
  415: 'ligdiWrongOtp',
  479: 'withdrawToOwnWalletNotAllowed',
  ACCOUNT_DISABLED: 'accountDisabled',
  INVALID_CREDENTIALS: 'invalidCredentials',
  KYC_AUTHORIZATION_UNAVAILABLE: 'kycAuthorizationUnavailable',
  KYC_CONFIGURATION_INVALID: 'kycAuthorizationUnavailable',
  KYC_REQUIRED: 'kycRequired',
} as const;
